module.exports = __webpack_public_path__ + "assets/icons/wordpress-05a4.svg";